module.exports = __webpack_public_path__ + "927bd3204130f86ed9acadef847b25a2.svg";